import { Checkbox } from '@mui/material';
import { useSelectionContext } from 'common/contexts/SelectionContext';
import * as React from 'react';

interface Props {
  inputProps: Record<string, string>;
  checked?: boolean;
  indeterminate?: boolean;
}

/**
 * Differentiates between header and row checkboxes based on their props
 * This is the hackiest function; there isn't an obvious indication on the props
 * so right now we use the aria label which differs between header and row checkboxes.
 * @param props the props passed to the checkbox component
 * @returns 'header' if this is a header checkbox, or 'row' otherwise
 */
const determineCheckboxType: (props: Props) => 'header' | 'row' = (props) => {
  const ariaLabel = props.inputProps['aria-label'] as string;
  if (ariaLabel.includes('all')) {
    return 'header';
  }

  return 'row';
};

/**
 * This component does some hacky, fragile, stuff to differentiate
 * between the header checkbox and row checkboxes
 * @param props
 * @returns
 */
export const MagicCheckbox: React.FC<Props> = React.forwardRef<HTMLButtonElement, Props>(
  (props: Props, ref) => {
    const type = determineCheckboxType(props);

    const { selection } = useSelectionContext();

    if (type === 'row') {
      return (
        <Checkbox
          {...props}
          ref={ref}
          disableRipple
          className="cursor-default p-2 m-2 ml-3"
          sx={{
            svg: {
              display: 'none',
            },
            '&.MuiCheckbox-root input': {
              opacity: 1,
              borderRadius: '0.25rem',
              borderColor: '#CDD0E0', // gray-300,
            },
          }}
        />
      );
    }

    const { checked: ignoredChecked, indeterminate: ignoredIndeterminate, ...rest } = props;

    const indeterminate =
      selection.model === 'page' && selection.containers.length !== selection.totalCount;
    const checked = selection.model !== 'none';

    return (
      <Checkbox
        indeterminate={indeterminate}
        checked={checked}
        {...rest}
        ref={ref}
        disableRipple
        className="cursor-default p-2 m-2 ml-3"
        sx={{
          svg: {
            display: 'none',
          },
          '&.MuiCheckbox-root input': {
            opacity: 1,
            borderRadius: '0.25rem',
            borderColor: '#CDD0E0', // gray-300,
          },
        }}
      />
    );
  }
);
